/**
 * MD-14 FE-LANDINGS - universal landing copy (`/`)
 *
 * Reference: F-FE-LANDINGS.md Sec.1 + STRATEGY Sec.4. Marketer-locked copy.
 * Modifications require marketer review + DECISIONS supersede.
 */

import type { LandingCatalog } from './landing-types';

export const universalVi: LandingCatalog<'vi'> = {
  meta_title: 'Asklaw - Trợ lý pháp lý AI Việt Nam',
  meta_description:
    'Hỏi bất kỳ vấn đề pháp lý Việt Nam, nhận trích dẫn Điều/Khoản đối chiếu được từ kho VBPL chính thức.',
  hero_eyebrow: 'Trợ lý pháp lý AI',
  hero_headline: 'Hỏi bất kỳ vấn đề pháp lý Việt Nam, nhận trích dẫn Điều/Khoản đối chiếu được',
  hero_subhead:
    'Bao phủ toàn bộ kho VBPL chính thức (166 nghìn văn bản từ vbpl.moj.gov.vn). 3 chế độ: Hỏi - Shortcut - Doc Pack.',
  cta_primary: 'Hỏi ngay miễn phí',
  cta_secondary: 'Xem Doc Pack',
  feature_1_title: 'Trích dẫn chính xác',
  feature_1_body:
    'Mọi câu trả lời kèm trích dẫn Điều/Khoản từ VBPL chính thức. Tỷ lệ trích dẫn đúng >=95%.',
  feature_2_title: 'Hiệu lực thời gian thực',
  feature_2_body:
    'Asklaw kiểm tra hiệu lực CHL/CCHL/HHL trước khi trả lời. Văn bản hết hiệu lực sẽ bị từ chối.',
  feature_3_title: 'Nhiều ngôn ngữ',
  feature_3_body:
    'Hỗ trợ tiếng Việt và tiếng Anh. Phù hợp cho người nước ngoài làm việc tại Việt Nam.',
  pricing_intro: 'Hỏi miễn phí. Doc Pack từ 199.000đ. Gói Pro sắp ra mắt.',
  footer_disclaimer:
    'Asklaw là công cụ AI tham khảo thông tin pháp luật, KHÔNG phải dịch vụ tư vấn pháp lý. ' +
    'Mọi kết quả do AI tạo, có thể sai sót. Để được tư vấn chính thức cho vụ việc cụ thể, ' +
    'vui lòng liên hệ luật sư có chứng chỉ hành nghề.',
};

export const universalEn: LandingCatalog<'en'> = {
  meta_title: 'Asklaw - AI Legal Copilot for Vietnam',
  meta_description:
    'Ask any Vietnamese legal question, get verifiable Article/Clause citations from the official VBPL corpus.',
  hero_eyebrow: 'AI Legal Copilot',
  hero_headline: 'Ask any Vietnamese legal question, get verifiable Article/Clause citations',
  hero_subhead:
    'Covers the full official VBPL corpus (166k documents from vbpl.moj.gov.vn). 3 modes: Ask - Shortcut - Doc Pack.',
  cta_primary: 'Try free',
  cta_secondary: 'See Doc Pack',
  feature_1_title: 'Accurate citations',
  feature_1_body:
    'Every answer ships with Article/Clause citations from the official VBPL corpus. Citation accuracy >=95%.',
  feature_2_title: 'Real-time validity',
  feature_2_body:
    'Asklaw checks effective status (CHL/CCHL/HHL) before answering. Expired text is refused.',
  feature_3_title: 'Bilingual',
  feature_3_body:
    'Vietnamese + English. Built for foreign workers and expats in Vietnam.',
  pricing_intro: 'Ask for free. Doc Pack from $19. Pro tier coming soon.',
  footer_disclaimer:
    'Asklaw is an AI tool for legal information reference only, NOT a legal advisory service. ' +
    'All outputs are AI-generated and may contain errors. For formal advice on specific matters, ' +
    'please consult a licensed Vietnamese lawyer.',
};
